/* eslint-disable max-len */
import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { LANGUAGES } from 'src/app/conf/languages';
import { AppState } from 'src/app/store/app.reducer';
import * as UserActions from 'src/app/store/user/user.actions';
import * as NotificationsActions from "src/app/store/notifications/notifications.actions";
import * as DeviceActions from 'src/app/store/device/device.actions';
import { NewDeviceModel } from 'src/app/model/device-model';
import { debounceTime, from, groupBy, map, Observable, Subscription } from 'rxjs';
import { selectNewDeviceModels } from 'src/app/store/device/device.selector';
import { AUTOMATION_CLASS_LIST } from 'src/app/conf/automation-class';
import { EDeviceModel } from 'src/app/conf/device-models';
import { EDeviceCategory } from 'src/app/conf/device-categories';
import { ICON_CONVERT_TAPPARELLA, ICON_CONVERT_VIRTUAL_DEVICE } from 'src/app/conf/icon';
import { convertDbStandartIcon, convertOldIcon, DeviceIcon } from 'src/app/conf/device-icons';
import { FormControl, FormGroup } from '@angular/forms';
import { StandardPageLayout } from '../../shared/stdlayoutlib/classes.stdlayoutlib';

@Component({
	selector: 'app-list-device-support',
	templateUrl: './list-device-support.component.html',
})
export class ListDeviceSupportComponent implements OnInit, OnDestroy {
	@Input() mobile: boolean;

	models$: Observable<NewDeviceModel[] | undefined>;
	modelsSub: Subscription | undefined;

	filterModels: NewDeviceModel[];
	models: NewDeviceModel[];
	modelSubGateway: NewDeviceModel[];
	boardClasses = AUTOMATION_CLASS_LIST;

	browserDeviceScreen = 960;

	visibleCameInfo = true;

	filter: '';
	// filterForm: FormGroup;
	filterGroup: FormGroup;
	filterSub: Subscription;


	// design
	screenWidth: number;
	MIN_MD_WIDTH = 500;
	MIN_MD_WIDTH_EXT = 670;
	MAX_MD_WIDTH = 1120;
	MIN_WIDTH_COL4 = 1530;
	MIN_WIDTH_MX7 = 1700;


	constructor(
		private route: ActivatedRoute,
		private translate: TranslateService,
		private store: Store<AppState>
	) {
		this.initSelectors();
	}

	initSelectors(): void {
		// Store selectors
		this.models$ = this.store.select(selectNewDeviceModels);
	}

	ngOnDestroy(): void {
		this.modelsSub?.unsubscribe();
	}

	ngOnInit() {
		this.store.dispatch(NotificationsActions.setTopbarTitleId({
			stringId: 'COMPLIANT_DEVICES'
		}));
		this.store.dispatch(DeviceActions.getNewDeviceModels({}));
		const lang = this.route.snapshot.queryParamMap.get('language');
		const langVal = LANGUAGES.find(l => l.code === lang);
		if (langVal !== undefined) {
			this.store.dispatch(UserActions.setCurrentLang({ lang: langVal }));
			if (langVal.code !== this.translate.currentLang && localStorage != null) {
				window.location.reload();
			}
		}
		this.subscribeAll();


		this.translate.onLangChange.subscribe(() => {
			//this.changeLegends();
		});


		this.filterGroup = new FormGroup({
			'searchFilter': new FormControl(''),
			'type': new FormControl(null),
		});


		const visibleCameInfoParam = this.route.snapshot.queryParamMap.get('cameInfo');
		if (visibleCameInfoParam != null && visibleCameInfoParam === 'false') {
			this.visibleCameInfo = false;
		}
		this.filterSub = this.filterGroup.valueChanges.pipe(
			debounceTime(500),
		).subscribe(() => {
			this.filterList();
		});
		this.onResize();
	}


	subscribeAll(): void {
		this.modelsSub = this.models$
			.pipe(
				map(models => this.supportedModels(models))
			)
			.subscribe(models => {
				this.models = models.filter(model => model.Id < 900 && model.CategoryId !== 2);
				const listBoardClass = Object.keys(this.models.reduce((r, { BoardClass }) => (r[BoardClass] = '', r), {}));


				const allClassList = Object.assign([], AUTOMATION_CLASS_LIST);
				this.boardClasses = Object.assign([], allClassList.filter(clas => (clas.BoardClass !== 1000 && listBoardClass.includes(this.toStringUndeff(clas.BoardClass)) || (clas.BoardClass === 1000 && this.modelSubGateway !== undefined && this.modelSubGateway.length > 0))));


				const listSeries = [];
				from(models).pipe(
					groupBy(p => p.SeriesName)
				).subscribe((groupedObservable) => {
					if (groupedObservable.key !== undefined && groupedObservable.key !== "") {
						listSeries.push(groupedObservable.key);
					}
				});
				this.filterModels = this.models;
			}
			);
	}

	supportedModels(allModels: NewDeviceModel[]): NewDeviceModel[] {
		let models: NewDeviceModel[] = [];
		//models = models.concat(allModels.filter(m => m.Id === EDeviceModel.MultiIO));
		models = models.concat(
			allModels.filter(m => m.CategoryId === EDeviceCategory.Automation && m.SeriesName !== '')); // Automations only
		return models;
	}

	toStringUndeff(num: number): string {
		if (num === undefined)
			return "undefined";
		return num.toString();
	}


	/*getIcon(deviceModel: NewDeviceModel): string {
		if (deviceModel.Id !== EDeviceModel.MultiIO) {
			return this.convertIcon('cm-' + DeviceIcon[deviceModel.Id]);
		} else {
			return this.convertIcon('cm-' + deviceModel.IconName.toLowerCase() || 'cm-' + DeviceIcon[deviceModel.Id] || 'cm-device-gateway');
		}
	}*/

	getIcon(deviceModel: NewDeviceModel): string {
		let icon = '';
		if (deviceModel.Id !== EDeviceModel.MultiIO) {
			icon = 'cm-' + DeviceIcon[deviceModel.Id];
		} else {
			icon = 'cm-' + deviceModel.IconName.toLowerCase() || 'cm-' + DeviceIcon[deviceModel.Id] || 'cm-device-gateway';
		}
		switch (icon) {
			case 'cm-undefined': {
				return convertDbStandartIcon(deviceModel.IconName);
			}
			default: {
				return convertOldIcon(icon);
			}
		}
	}


	getBoardClass(deviceModel: NewDeviceModel): string {
		if (deviceModel.BoardClass !== undefined) {
			const cl = this.boardClasses.filter(brc => brc.BoardClass === deviceModel.BoardClass);
			return cl !== undefined && cl.length > 0 ? this.translate.instant(cl[0].BoardName) + ' - ' : '';
		}
		return '';
	}

	get f(): any {
		return this.filterGroup.controls;
	}

	filterList(): void {

		const search = this.f.searchFilter.value;
		const type = this.f.type.value;
		this.filterModels = this.models;

		//<span class="font-bold ml-2">{{getBoardClass(customer)}}</span>
		//<span class="font-bold ml-2">{{customer.SeriesName}}</span>
		if (search !== undefined && search !== '') {
			this.filterModels = this.filterModels.filter(model => this.getBoardClass(model).toLowerCase().includes(search.toLowerCase()) ||
				model.SeriesName.toLowerCase().includes(search.toLowerCase()) || model.BoardProductName.toLowerCase().includes(search.toLowerCase()));
		}

		if (type !== undefined && type !== null) {
			this.filterModels = this.filterModels.filter(model => model.BoardClass === type.BoardClass);
		}
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-23rem');
	}

	col6ResponsiveMainFilter(alignment: string): string {
		return StandardPageLayout.col6ResponsiveMainFilter(this.screenWidth, alignment);
	}

	layoutMarginResponsive(): string {
		return StandardPageLayout.layoutMarginResponsive(this.screenWidth);
	}

	simpleInputTextLayout(classType: string): string {
		return StandardPageLayout.simpleInputTextLayout(classType, this.screenWidth);
	}

	tabletUnderMinWdCol6(): boolean {
		return StandardPageLayout.tabletUnderMinWdCol6(this.screenWidth);
	}
}
